// extracted by mini-css-extract-plugin
export default {"root":"PageKidG_root__muv4s","content":"PageKidG_content__XvqlI","back":"PageKidG_back__yJMlk"};